// React
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

// MUI
import { CircularProgress, Stack, Typography } from "@mui/material";

// QR Components
import { readBarcodes } from "zxing-wasm/reader";
import { QRCloseButton } from "../QRCloseButton";
import processQRData from "../ProcessQRData";
import { QR_STATES } from "Constants/QRConstants";
import { useQR } from "../QRContext";

// Components
import DropzoneArea from "Components/Dropzone";

// Style
import styles from "../styles";

/**
 * @brief QR Code file reader component
 */
export const QRCodeReader = () => {
  const { t } = useTranslation();

  const { qrState, setQRState, setQRJSON } = useQR();
  const [reading, setReading] = useState(false);
  const [files, setFiles] = useState([]);
  const [codes, setCodes] = useState(undefined);

  const readFromFile = (fileList) => {
    if (fileList?.length > 0) {
      setFiles(fileList);
    }
  };

  useEffect(() => {
    const processFiles = async () => {
      if (files?.length === 0) {
        return;
      }

      setReading(true);

      const codesScanned = await readBarcodes(files[0], {
        tryHarder: true,
        formats: ["QRCode"],
      });

      setCodes(codesScanned);

      setReading(false);
    };

    processFiles();
  }, [files]);

  useEffect(() => {
    if (codes !== undefined && qrState === QR_STATES.OPEN) {
      if (codes.length > 0) {
        const hcJSON = processQRData(codes[0].text);

        if (!hcJSON) {
          setQRState(QR_STATES.FAIL);
          return;
        }

        setQRJSON(hcJSON);
        setQRState(QR_STATES.SUCCESS);
      } else {
        setQRState(QR_STATES.FAIL);
      }
    }
  }, [codes, qrState, setQRState, setQRJSON]);

  return (
    <Stack alignItems="center">
      {reading ? (
        <Stack alignItems="center" spacing={2}>
          <CircularProgress size="4rem" color="inherit" />
          <Typography sx={styles.mainText} textAlign="center">
            {t("qrcode.scanInProgress")}
          </Typography>
        </Stack>
      ) : (
        <DropzoneArea
          title={t("qrcode.uploadInstructions")}
          handleUpload={readFromFile}
        />
      )}
      <QRCloseButton />
    </Stack>
  );
};
